import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const StlyedPath = styled('path')`
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  transition: fill 0.2s ease;
  ${media.lgUp`
    &:hover {
      fill: ${({ theme }) => theme.color.whiteRGBA(0.2)};
    }
  `}
  ${media.mdDown`
    &:focus {
      fill: ${({ theme }) => theme.color.whiteRGBA(0.2)};
    }
  `}
`;
